import { applyMiddleware, Reducer, Store, StoreEnhancer, legacy_createStore as createStore, Middleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import { PersistPartial } from 'redux-persist/lib/persistReducer';

import { rootReducer } from 'app/redux/reducer/root-reducer';
import { RootState } from 'app/redux/state/root-state';
import { history } from 'app/service/navigation-service';

import { rootPersistConfig } from './store-config';

const configureStore = (initialState?: RootState & PersistPartial): Store<RootState> => {
    const mainMiddleware: StoreEnhancer = configureMiddleware();
    const reducer: Reducer<RootState & PersistPartial> = configurePersistReducer();

    return createStore(reducer, initialState, mainMiddleware);
};

const configureMiddleware = (): StoreEnhancer => {
    const historyMiddleware: Middleware = routerMiddleware(history);

    return composeWithDevTools(applyMiddleware(thunkMiddleware, historyMiddleware));
};

const configurePersistReducer = (): Reducer<RootState & PersistPartial> =>
    persistReducer(rootPersistConfig, rootReducer(history));

const store: Store<RootState> = configureStore();

export { store };
